module.exports = __webpack_public_path__ + "static/media/ico_error.6c1fd771.svg";